import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=19d34163&scoped=true&"
import script from "./prescription.vue?vue&type=script&lang=js&"
export * from "./prescription.vue?vue&type=script&lang=js&"
import style0 from "./prescription.vue?vue&type=style&index=0&id=19d34163&scoped=true&lang=less&"
import style1 from "./prescription.vue?vue&type=style&index=1&lang=less&"
import style2 from "./prescription.vue?vue&type=style&index=2&id=19d34163&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d34163",
  null
  
)

export default component.exports